import React, { LegacyRef } from 'react';
import { MomentInput } from 'moment';

import { localTime } from '@helpers';
import { font } from '@styles/fonts';

import { LegendRules } from '@components/machines/components/timeline/calculations/index';
import { ColorFunction } from '@styles/colors/types';

export default (props: { C: ColorFunction; timelineRef: LegacyRef<HTMLDivElement>; startTime: MomentInput; rules: LegendRules }) => {
  const { C, timelineRef, startTime, rules } = props;

  return (
    <div
      ref={timelineRef}
      style={{
        display: 'flex',
        width: '100%',
        flexDirection: 'row',
        paddingBottom: 24,
      }}
    >
      <div style={{ width: rules.initialOffsetSeconds * rules.secondWidth, height: 25, position: 'relative' }}>
        {Array.from({ length: rules.amountOfInitialSmallLine }).map((_, index) => (
          <div
            style={{
              position: 'absolute',
              left: `${index * rules.smallLineDistance + rules.initialSmallLineOffsetSeconds * rules.secondWidth}px`,
              top: '0',
              width: 1,
              height: 5,
              borderBottomLeftRadius: 1,
              borderBottomRightRadius: 1,
              backgroundColor: C('Gray/Light/3'),
            }}
            key={`machine-small-line-start-${index}`}
          />
        ))}
      </div>
      {Array.from({ length: rules.amountOfBigLine }).map((_, i) => {
        const initialTime = localTime(startTime).add(rules.initialOffsetSeconds, 'second').format();
        const isNewDay =
          localTime(initialTime)
            .add(rules.interval.primary * (i - 1), 'second')
            .format('DD') !==
          localTime(initialTime)
            .add(rules.interval.primary * i, 'second')
            .format('DD');

        const primaryFormat = isNewDay ? 'MMM-DD' : rules.interval.primaryFormat;

        const isLastElementNewDay =
          localTime(initialTime)
            .add(rules.interval.primary * i, 'second')
            .format('DD') !==
          localTime(initialTime)
            .add(rules.interval.primary * (i + 1), 'second')
            .format('DD');

        const lastElementFormat = isLastElementNewDay ? 'MMM-DD' : rules.interval.primaryFormat;

        return (
          <div style={{ width: rules.bigLineDistance, height: 25, position: 'relative' }} key={`machine-time-${i}`}>
            <div
              style={{
                display: 'flex',
                flexDirection: 'column',
                alignItems: 'center',
                width: rules.bigLineDistance,
                left: -rules.bigLineDistance / 2,
                position: 'absolute',
              }}
            >
              <div
                style={{
                  width: 1,
                  height: 10,
                  borderBottomLeftRadius: 1,
                  borderBottomRightRadius: 1,
                  backgroundColor: C('Gray/Light/1'),
                }}
              />
              <div style={{ ...font['Footnote'], color: C('Label/Light/Primary'), lineHeight: 2, userSelect: 'none' }}>
                {localTime(initialTime)
                  .add(rules.interval.primary * i, 'seconds')
                  .format(primaryFormat)}
              </div>
            </div>
            {Array.from({ length: rules.amountOfSmallLine - 1 }).map((_, index) => (
              <div
                style={{
                  position: 'absolute',
                  left: `${((index + 1) * rules.bigLineDistance) / rules.amountOfSmallLine - 1}px`,
                  top: '0',
                  width: 1,
                  height: 5,
                  borderBottomLeftRadius: 1,
                  borderBottomRightRadius: 1,
                  backgroundColor: C('Gray/Light/3'),
                }}
                key={`machine-small-line-${i}-${index}`}
              />
            ))}
            {i === rules.amountOfBigLine - 1 && (
              <>
                {Array.from({ length: rules.amountOfAdditionalSmallLine }).map((_, index) => (
                  <div
                    style={{
                      position: 'absolute',
                      left: `${rules.bigLineDistance + rules.smallLineDistance * (index + 1)}px`,
                      top: '0',
                      width: 1,
                      height: 5,
                      borderBottomLeftRadius: 1,
                      borderBottomRightRadius: 1,
                      backgroundColor: C('Gray/Light/3'),
                    }}
                    key={`machine-small-line-finish-${i}-${index}`}
                  />
                ))}
                <div
                  style={{
                    display: 'flex',
                    flexDirection: 'column',
                    alignItems: 'center',
                    width: rules.bigLineDistance,
                    right: -rules.bigLineDistance / 2,
                    position: 'absolute',
                  }}
                >
                  <div
                    style={{
                      width: 1,
                      height: 10,
                      borderBottomLeftRadius: 1,
                      borderBottomRightRadius: 1,
                      backgroundColor: C('Gray/Light/1'),
                    }}
                  />
                  <div style={{ ...font['Footnote'], color: C('Label/Light/Primary'), lineHeight: 2, userSelect: 'none' }}>
                    {localTime(initialTime)
                      .add(rules.interval.primary * (i + 1), 'second')
                      .format(lastElementFormat)}
                  </div>
                </div>
              </>
            )}
          </div>
        );
      })}
    </div>
  );
};
